export default "__VITE_ASSET__54c9d194__"